/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOnePopover/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaSelectOnePopover({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOnePopover",
  optionsWidth = "100%",
  optionsRef,
  isShowingOptions,
  optionsTop = 42,
  optionsLeft = 0,
  paddingLeft,
  paddingRight,
  paddingTop = 12,
  paddingBottom = 12,
  innerRef,
  maxHeight = 250,
  overflowY = "auto",
  size,
  isShowingAddFilterAsCustomOption,
  onClickAddFilterAsCustomOption,
  isMultiChoice,
  disabled,
  isSelected,
  isSelectedAll,
  onClick,
  onClickToggleAll,
  from,
  fromCustom,
  valueFilter,
  showSelectAll
  
}) {
  let isBefore = useIsBefore()
let dtTysiainputdatepickerBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.backgroundColor.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let paddingLeftOrdtSpaceXs = paddingLeft ?? dtSpaceXs
let paddingRightOrdtSpaceXs = paddingRight ?? dtSpaceXs
  return (<React.Fragment
>
<fromFlow.When is={isShowingOptions}>
<div
  data-testid="TysiaSelectOnePopover.Vertical"
  data-view-path={viewPath}
 ref={optionsRef}
 style={{'--w-1-Z5rdDz': typeof optionsWidth === 'number' ? `${optionsWidth}px` : optionsWidth,'--t-2-Z5rdDz': typeof optionsTop === 'number' ? `${optionsTop}px` : optionsTop,'--l-3-Z5rdDz': typeof optionsLeft === 'number' ? `${optionsLeft}px` : optionsLeft}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TysiaSelectOnePopover.Vertical:1"
  data-view-path={viewPath}
 tabIndex={-1}
 ref={innerRef}
 style={{'--bc-4-Z5rdDz': dtTysiainputdatepickerBackgroundcolorPrimaryBase,'--bblr-5-Z5rdDz': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z5rdDz': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-7-Z5rdDz': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-8-Z5rdDz': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-9-Z5rdDz': dtColorsNeutral300,'--mh-14-Z5rdDz': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--oy-15-Z5rdDz': overflowY,'--o-16-Z5rdDz': isBefore ? 0 : 1,'--ty-17-Z5rdDz': isBefore ? "-10px" : "0px",'--pl-10-Z5rdDz': size === "small" ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : typeof paddingLeftOrdtSpaceXs === 'number' ? `${paddingLeftOrdtSpaceXs}px` : paddingLeftOrdtSpaceXs,'--pr-11-Z5rdDz': size === "small" ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : typeof paddingRightOrdtSpaceXs === 'number' ? `${paddingRightOrdtSpaceXs}px` : paddingRightOrdtSpaceXs,'--pt-12-Z5rdDz': size === "small" ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-13-Z5rdDz': size === "small" ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom}}
 className={`views-block ${styles.Vertical1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isMultiChoice={isMultiChoice}
 size={size}
 disabled={disabled}
 isSelected={isSelected}
 isSelectedAll={isSelectedAll}
 onClick={onClick}
 onClickToggleAll={onClickToggleAll}
 from={from}
 fromCustom={fromCustom}
 valueFilter={valueFilter}
 showSelectAll={showSelectAll}
>
{children}
</Children>
</div>
</div>
</fromFlow.When>
</React.Fragment>)
}